export default __webpack_public_path__ + "static/20-1aecb0328178a0f451f3ab2d676f9d1f.png";